import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateEarmarkConversionStatusReduxParams } from '~types/feat/approval';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';

export default function* watchUpdateEarmarkConversionStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateEarmarkConversionStatusAttempt', handleUpdateEarmarkConversionStatus, api);
}

function* handleUpdateEarmarkConversionStatus(api: ApprovalGateway, data: PayloadAction<TUpdateEarmarkConversionStatusReduxParams>) {
    const authToken = store.getState().auth.userDetails.authToken;
    const { id, status } = data.payload;

    if (!id || !status) {
        yield put(combinedActions.approvalUpdateEarmarkConversionStatusFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.updateEarmarkConversionStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateEarmarkConversionStatusFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalUpdateEarmarkConversionStatusSuccess());
        yield put(combinedActions.approvalSetConfirmUpdateEarmarkConversionStatusModalIsOpen(false));

        yield put(combinedActions.goldGetEarmarkConversionListingAttempt({ index: 0 }));
    }
}
